// https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
( function () {
   'use strict';
   jQuery.extend( true, e4.settings, {
       scrollToAnchor: {
           speed: 0.15,
           nudge: 2,
           easing: 'swing',
           stickyElements: '.js-e-header.is-sticky, .js-e-nav-local-horizontal.is-sticky',
           fullscreenElements: '.e-section-height-fullscreen, .p-section-fullscreen, .p-banner-fullscreen',
           backToTop: {
               revealOffset: 1
           }
       },
       search: {
           result: {
               pages: {
                   show: true,
                   url: '/system/data/pages?q='
               },
               products: {
                   show: false,
                   url: '/system/data/products?q=',
                   showAllLink: '/shop/search?q=',
                   max: {
                       xs: 2,
                       sm: 2,
                       md: 4,
                       lg: 4,
                       xl: 5
                   }
               }
           }
       },       
   } );
}() );

